import { PromocodesOfferType } from '@occc/graphql';

export const MAX_PROMOCODES_LENGTH = 50;
export const MIN_PROMOCODE_VALUE_LENGTH = 1;
export const MAX_PROMOCODE_VALUE_LENGTH = 200;
export const MAX_PROMOCODE_DESCRIPTION_LENGTH = 255;
export const PROMOCODE_VALIDATION_MESSAGE = `Promo code must be ${MIN_PROMOCODE_VALUE_LENGTH}-${MAX_PROMOCODE_VALUE_LENGTH} characters, only letters and numbers (no spaces)`;

export const PROMOCODES_CODES_TYPE_OPTIONS = [
  { title: 'Global', value: PromocodesOfferType.Global },
  { title: 'Individual', value: PromocodesOfferType.Individual },
];

export const PROMO_CODE_GROUPS_POLL_INTERVAL_MS = 3000;
